import * as React from 'react';

import { ChatRoomType, ChatPlugin } from '@common/react/components/Chat/Chat';
import VideoChatButton, { LastMessage } from '@common/react/components/UI/VideoChat/VideoChatButton';

const Message = ({
	message, withRemoteId, lastVideoCallId, contacts,
}) => <>
	<div className="chat-message-list-component__item-call-button">
		<VideoChatButton
			roomType={message.chatRoomType}
			chatId={message.chatId}
			notifyUserIds={contacts.map((item) => item.id)}
			roomId={message.text}
			roomName={withRemoteId ? message.chat?.name ?? 'Unknown' : message.text.split('_')[1]}
			disabled={lastVideoCallId !== message.id}
		/>
	</div>
</>;

const messagesHeaderAction = ({
	withRemoteId, currentChat, user, navigate, patientId,
}) => {
	const userCall = currentChat.contacts.find((item) => (withRemoteId ? item.remoteId === null : item.id !== user.id));
	return currentChat.contacts.length <= 2 && <VideoChatButton
		roomType={ChatRoomType.Video}
		roomId={`${currentChat.id}_${currentChat.name}`}
		roomName={`${userCall?.firstName} ${userCall?.lastName}`}
		chatId={currentChat.id}
		notifyUserIds={withRemoteId ? [user.id, userCall.id] : currentChat.contactsIds}
		avatar={userCall?.avatar}
		title={withRemoteId ? 'Video call to the patient' : 'Video Call'}
		className="btn btn-sm btn-primary pull-right"
	/>;
};

export const VideoChatPlugin: ChatPlugin = {
	message: {
		render: Message,
		lastMessage: LastMessage,
	},
	messagesHeaderAction,
	options: {
		request: 'videoChat',
	},
};
